import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-defee028"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "relative page" }, null, -1))
const _hoisted_2 = { class: "logout" }
const _hoisted_3 = { class: "wrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "background-noise" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "skyline-logo" }, null, -1))
const _hoisted_6 = { class: "body" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<pre class=\"text-military-green-500\" data-v-defee028>Welcome to Skyline</pre><h3 class=\"font-normal text-rust-500\" data-v-defee028>Verification</h3><div class=\"my-8\" data-v-defee028></div><p class=\"message\" data-v-defee028>Your account is not verified</p><p class=\"message\" data-v-defee028>Check inbox for confirmation email</p><br data-v-defee028><p class=\"sub-message\" data-v-defee028>If you&#39;re having issues, check your spam</p>", 7)
const _hoisted_14 = { class: "h-4 success" }
const _hoisted_15 = { key: 0 }

import { useGlobalStore } from '../store/globalStore';
import { storeToRefs } from 'pinia';
import LoginButtonComponent from '../components/LoginButtonComponent.vue';
import { AuthClient } from '../services/auth';
import { ref } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'VerificationPage',
  setup(__props) {

const { firebaseUser, currentUser } = storeToRefs(useGlobalStore());

const resendEmail = async () => {
  const result = await AuthClient.getInstance().sendEmailVerification();
  if (result) {
    verificationMessageResult.value = 'Error sending verification email';
    return;
  }
  verificationMessageResult.value = 'Verification email sent!';
};

const verificationMessageResult = ref('');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(LoginButtonComponent, {
        class: "mt-2 text-xs",
        isLoggedIn: _unref(currentUser) !== null,
        isEmailVerified: _unref(firebaseUser)?.emailVerified,
        currentUser: _unref(currentUser)
      }, null, 8, ["isLoggedIn", "isEmailVerified", "currentUser"])
    ]),
    _createElementVNode("section", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("p", {
          class: "cursor-pointer message",
          onClick: resendEmail
        }, "Resend Email"),
        _createElementVNode("div", _hoisted_14, [
          (verificationMessageResult.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(verificationMessageResult.value), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}
}

})